import { CrudForm } from '../shared/CrudPage';
import { tenantDomainMapService, enumEntries } from '@kss/api';
import type { TenantDomainMap, TenantDomainMapCreate, TenantDomainMapFilter } from '@kss/api';
import { loadTenantOptions } from '../shared/formLoaders';

type F = { tenantId: string; domain: string; isPrimary: boolean; status: string };
const empty: F = { tenantId: '', domain: '', isPrimary: false, status: '1' };

export default function NewTenantDomainMap() {
  return (
    <CrudForm<TenantDomainMap, TenantDomainMapCreate, TenantDomainMapFilter, F>
      title="domain mapping"
      service={tenantDomainMapService}
      idKey="tenantDomainMapId"
      basePath="/panel/tenant-domain-maps"
      emptyForm={empty}
      fields={[
        { key: 'domain', label: 'Domain', required: true, placeholder: 'acme.kssmart.local' },
        // Tenant picker: SearchableSelect backed by tenantService.all().
        // Eager-loads in edit mode so the saved tenant name appears
        // immediately instead of the raw UUID.
        {
          key: 'tenantId',
          label: 'Tenant',
          type: 'search',
          required: true,
          loadOptions: loadTenantOptions,
          placeholder: 'Pick a tenant',
        },
        { key: 'isPrimary', label: 'Primary', type: 'status' },
        {
          key: 'status',
          label: 'Status',
          type: 'select',
          options: enumEntries('TenantDomainStatus').map((e) => ({ value: String(e.value), label: e.label })),
        },
      ]}
      fromEntity={(r) => ({
        tenantId: r.tenantId ?? '',
        domain: r.domain ?? '',
        isPrimary: !!r.isPrimary,
        status: String(r.status ?? '1'),
      })}
      toEntity={(f, id) => ({
        tenantDomainMapId: id,
        tenantId: f.tenantId,
        domain: f.domain,
        isPrimary: f.isPrimary,
        status: f.status ? Number(f.status) : undefined,
      })}
      validate={(f) =>
        !f.domain.trim() ? 'Domain is required' : !f.tenantId.trim() ? 'Tenant is required' : null
      }
    />
  );
}
